import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import moment from "moment";
import { EditButton, ModalContent, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ScrollableContent } from "../Styles/InputStyles";
import { ProfileSection, UserInfo } from "../Styles/PageStyles";
import Config from "../../Config";

const getValueOrDashedIcon = (value) => {
  if (value === null || value === undefined || value === "Invalid date" || value === "") {
    return <span >-</span>;
  }
  return value;
};


const getValidDateOrDashedIcon = (date) => {

  if (!date) {
    return <span >-</span>;
  }

  const formattedDate = moment(date);

  if (!formattedDate.isValid()) {
    return <span className="text-gray-400">—</span>;
  }

  return formattedDate.format("DD-MMM-YY");
};

const ViewDetails = ({
  setViewDetail,
  selectedData,
  setEditBasicDetail,
  setIsAssignmentDetails,
  setIsDeleteAsset,
  setAddAlertDetail,
  setEditAlertData
}) => {
  const onClose = () => {
    setViewDetail(false);
  };
  const onEditBasicDetails = () => {
    setViewDetail(false);
    setEditBasicDetail(true)
  };
  const onaddAlertDetails = () => {
    setViewDetail(false);
    setAddAlertDetail(true);
    setEditAlertData(null);
  };
  const onEditAlertDetails = (alert) => {
    setViewDetail(false);
    setAddAlertDetail(true);
    setEditAlertData(alert); // Pass the specific alert data for editing
  };
  const onAssignPropertyDetails = () => {
    setViewDetail(false);
    setIsAssignmentDetails(true)
  };
  const assetTypeMapping = {
    "Furniture & Fixtures": 1,
    "Electrical & Appliances": 2,
    "Plumbing & Sanitary": 3,
    "Security & Access Control": 4,
    "HVAC (Heating, Ventilation & Air Conditioning)": 5,
    "Outdoor & Common Area Assets": 6,
    "IT & Networking Equipment": 7,
    "Kitchen Equipment & Accessories": 8,
    "Miscellaneous Assets": 9,
    "Vehicle": 10,
  };
  const getAlertTypeLabel = (type) => {
    const alertTypeMap = {
      [Config.ASSET_INFO_TYPES.RTO_TAX_EXPIRY]: "RTO/Tax",
      [Config.ASSET_INFO_TYPES.INSURANCE_EXPIRY]: "Insurance",
      [Config.ASSET_INFO_TYPES.PUCC_EXPIRY]: "PUCC",
    };
    return alertTypeMap[type] || "Unknown";
  };
  const getName = (selectedData) => {
    const assetTypeName = Object.keys(assetTypeMapping).find(
      (key) => assetTypeMapping[key] === selectedData.type
    );
    return <p>{assetTypeName || "Unknown Type"}</p>;
  };

  const getStatusBadge = (status) => {
    const statusStyles = {
      1: "bg-green-100 text-green-700 text-xs border-green-300 border w-18 h-7 flex items-center justify-center rounded-full",
      2: "bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-18 h-7 flex items-center justify-center rounded-full",
      3: "bg-rose-100 text-rose-700 text-xs border-rose-300 border w-18 h-7 flex items-center justify-center rounded-full",
      4: "bg-gray-100 text-gray-800 text-xs border-gray-300 border w-18 h-7 flex items-center justify-center rounded-full",
    };

    const statusText = {
      1: "Active",
      2: "In Maintenance",
      3: "Disposed",
      4: "In Use",
    };

    return (
      <span
        className={`px-4 py-2 rounded-full text-xs ${statusStyles[status] || "bg-gray-100 text-gray-600"}`}
      >
        {statusText[status] || "Not Assigned"}
      </span>
    );
  };

  const handleDeleteExpense = () => {
    setIsDeleteAsset(true);
    // if (property?.id) {
    //   setPropId(property.id);
    // }
  };
  const formatAlertValue = (value) => {
    if (!value) return "-";
    const formattedDate = moment(value);
    if (!formattedDate.isValid()) {
      return value;
    }
    return formattedDate.format("DD, MMM YYYY");
  };
  const filteredAlerts = selectedData?.assetInfo?.filter(
    (alert) => alert.type !== 1
  ) || [];
  return (
    <Container>
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">{"Asset Details"}</h1>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <ProfileSection className="flex justify-between">

        <UserInfo>
          <span className="font-medium">{getName(selectedData)}</span>
          <span className="text-sm text-gray-600">
            {getValueOrDashedIcon(selectedData?.name)}
          </span>
        </UserInfo>
        <div className="flex gap-2">
          <span>{getStatusBadge(selectedData?.status)}</span>
          <MdDelete
            size={20}
            className="text-rose-500 cursor-pointer mt-1"
            title="Delete Expense"
            onClick={handleDeleteExpense}
          />
        </div>

      </ProfileSection>
      {selectedData?.totalExpense > 0 &&
      <div className="bg-rose-50 px-4 py-2">
        <p className="text-sm text-rose-400">Total Expenses: ₹{selectedData?.totalExpense}</p>
      </div>}
      <ModalContent>
        <ScrollableContent>
          <Wrapper>
            <BtnWrapper>
              <SectionTitle>Basic Details</SectionTitle>
              <EditButton title="Edit Basic Detail" onClick={onEditBasicDetails}
              >

                Edit</EditButton>
            </BtnWrapper>
            <ModalSection className="mb-3">
              {selectedData?.type !== 10 &&
                <ModalRow >
                  <FlexCol>
                    <ModalRowLabel>Total Units</ModalRowLabel>
                    <ModalRowValue>{getValueOrDashedIcon(selectedData?.total)}</ModalRowValue>
                  </FlexCol>
                  <FlexCol>
                    <div className="flex gap-4">
                      <ModalRowLabel>Remaining Units</ModalRowLabel>
                      {selectedData?.free > 0 &&
                        <EditButton title="Assign Property" onClick={onAssignPropertyDetails}
                        >Assign </EditButton>}
                    </div>
                    <ModalRowValue>{getValueOrDashedIcon(selectedData?.free)}</ModalRowValue>
                  </FlexCol>
                </ModalRow>}
              {selectedData?.vehicleNum &&
                <div className="pb-4 flex justify-between items-center">
                  <FlexCol>
                    <ModalRowLabel>Vehicle Number</ModalRowLabel>
                    <ModalRowValue>{selectedData?.vehicleNum}</ModalRowValue>
                  </FlexCol>
                  {selectedData?.free > 0 &&
                    <EditButton title="Assign Property" onClick={onAssignPropertyDetails}
                    >Assign </EditButton>}
                </div>}
              <div >
                <FlexCol>
                  <ModalRowLabel>Description</ModalRowLabel>
                  <ModalRowValue>{getValueOrDashedIcon(selectedData?.description)}</ModalRowValue>
                </FlexCol>
              </div>

            </ModalSection>

            <BtnWrapper>
              <SectionTitle>Purchase/Rent Details</SectionTitle>
            </BtnWrapper>
            <ModalSection className="mb-3">
              <ModalRow className="pb-4">
                <FlexCol>
                  <ModalRowLabel>Purchase/Rent Date</ModalRowLabel>
                  <ModalRowValue>{getValidDateOrDashedIcon(selectedData?.purchaseDate)}</ModalRowValue>
                </FlexCol>

                <FlexCol>
                  <ModalRowLabel>Purchase/Rent Price</ModalRowLabel>
                  <ModalRowValue>{getValueOrDashedIcon('₹' + selectedData?.cost)}</ModalRowValue>
                </FlexCol>
              </ModalRow>
              <ModalRow className="pb-4">
                <FlexCol>
                  <ModalRowLabel>Depreciation(%)</ModalRowLabel>
                  <ModalRowValue>{getValueOrDashedIcon(selectedData?.depreciationRate)}</ModalRowValue>
                </FlexCol>

                <FlexCol>
                  <ModalRowLabel>Vendor Name</ModalRowLabel>
                  <ModalRowValue>{getValueOrDashedIcon(selectedData?.vendorName)}</ModalRowValue>
                </FlexCol>
              </ModalRow>
              <ModalRow >
                <FlexCol>
                  <ModalRowLabel>Warranty Expire</ModalRowLabel>
                  <ModalRowValue>{getValidDateOrDashedIcon(selectedData?.warrentyExpire)}</ModalRowValue>
                </FlexCol>


              </ModalRow>

            </ModalSection>
            {selectedData?.type === 10 &&
              <><BtnWrapper>
                <SectionTitle>Alert</SectionTitle>
                <EditButton title="Add" onClick={onaddAlertDetails}
                >

                  Add</EditButton>
              </BtnWrapper>
                <ModalSection className="mb-3">
                  {/* {filteredAlerts.length > 0 ? (
                    filteredAlerts.map((alert, index) => (
                      <ModalRow key={alert.id || index} className={`flex justify-between items-center gap-4 py-3 ${index < filteredAlerts.length - 1 ? "pb-4" : ""}`}>
                        <FlexCol>
                          <ModalRowLabel>Type</ModalRowLabel>
                          <ModalRowValue>{getAlertTypeLabel(alert.type)}</ModalRowValue>
                        </FlexCol>
                        <FlexCol>
                                               <ModalRowLabel>Expiry Date</ModalRowLabel>

                                                 <ModalRowValue>{formatAlertValue(alert.value)}</ModalRowValue>
                        </FlexCol>
                        <FlexCol>
                          <EditButton title="Edit" onClick={() => onEditAlertDetails(alert)}
                          >Edit </EditButton>
                        </FlexCol>
                      </ModalRow>
                    ))
                  ) : (
                    <div >
                      <FlexCol >
                        <p className="text-gray-400 text-sm text-center py-2">No alerts added yet</p>
                      </FlexCol>
                    </div>
                  )} */}
                  {filteredAlerts.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-200 rounded-xl">
                        <thead >
                          <tr className="bg-gray-100 text-left uppercase text-gray-600 ">
                            <th className="p-3 border-b text-sm font-normal">Title</th>
                            <th className="p-3 border-b text-sm font-normal">Expiry Date</th>
                            <th className="p-3 border-b text-center text-sm font-normal">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {filteredAlerts.map((alert, index) => (
                            <tr
                              key={alert.id || index}
                              className="border-b hover:bg-gray-50"
                            >
                              <td className="p-3 text-sm">
                                {getAlertTypeLabel(alert.type)}
                              </td>

                              <td className="p-3 text-sm">
                                {formatAlertValue(alert.value)}
                              </td>

                              <td className="p-3 text-center">
                                <EditButton
                                  title="Edit"
                                  onClick={() => onEditAlertDetails(alert)}
                                >
                                  Edit
                                </EditButton>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div>
                      <p className="text-gray-400 text-sm text-center py-4">
                        No alerts added yet
                      </p>
                    </div>
                  )}
                </ModalSection>
              </>
            }
            {selectedData?.assetDocs && (
              <>
                <BtnWrapper>
                  <SectionTitle>Supported Documents</SectionTitle>
                </BtnWrapper>
                <ModalSection>
                  <ModalRow >

                    <FlexCol>
                      <ModalRowLabel>Invoice</ModalRowLabel>
                      {selectedData.assetDocs?.find((doc) => doc.type === 8) ? (
                        <a
                          href={selectedData.assetDocs.find((doc) => doc.type === 8)?.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline text-base"
                        >
                          Click to View
                        </a>
                      ) : (
                        "-"
                      )}
                    </FlexCol>


                    <FlexCol>
                      <ModalRowLabel>Warranty</ModalRowLabel>
                      {selectedData.assetDocs?.find((doc) => doc.type === 9) ? (
                        <a
                          href={selectedData.assetDocs.find((doc) => doc.type === 9)?.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline text-base"
                        >
                          Click to View
                        </a>
                      ) : (
                        "-"
                      )}
                    </FlexCol>
                  </ModalRow>
                </ModalSection>
              </>
            )}


          </Wrapper>
        </ScrollableContent>
      </ModalContent>
    </Container>
  );
};

const Wrapper = tw.div`grid gap-1.5 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-600`;
//const ModalSection = tw.div` border border-gray-200 p-3 rounded-lg`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
//const ModalRow = tw.div`grid grid-cols-2 `;
//const ModalRowLabel = tw.label`text-sm text-gray-400`;
//const ModalRowValue = tw.span`text-gray-600 text-base`;
const BtnWrapper = tw.div`w-full flex items-center justify-between `;
const FlexCol = tw.div`flex flex-col gap-0.5`
const Content = tw.div`p-4 flex flex-col gap-4`;
//const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`
export default ViewDetails;
